(() => {
  const node=document.querySelector('[data-drv-native-gift-settings]');
  if(!node)return;
  const config=JSON.parse(node.textContent);
  if(config.enabled!==true)return;
  const logic=window.DrvGiftLogic,registered=config.registered.map(String);
  const cartPath=window.routes.cart_url;
  let chain=Promise.resolve(),pending=0,failed=false;
  const disabled=new Map();
  const errorText=()=>window.cartStrings?.error||'Unable to update your cart. Please try again.';
  const showError=()=>{const el=document.querySelector('[data-drv-native-gift-error]');el.hidden=false;el.textContent=errorText();};
  const controls=()=>document.querySelectorAll('[name="checkout"], [data-drv-native-checkout]');
  function protect(){
    for(const control of controls()){
      if(pending||failed){if(!disabled.has(control))disabled.set(control,control.disabled);control.disabled=true;}
      else if(disabled.has(control)){control.disabled=disabled.get(control);disabled.delete(control);}
    }
  }
  function timedFetch(url,options={}){
    const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),15000);
    return fetch(url,{...options,signal:controller.signal}).finally(()=>clearTimeout(timer));
  }
  async function request(url,body){
    const endpoint=body&&!url.endsWith('.js')?url+'.js':url;
    const response=await timedFetch(endpoint,body?{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(body)}:{cache:'no-store'});
    const data=await response.json();
    if(!response.ok||data.status||data.errors)throw new Error(data.description||'Cart request failed');
    return data;
  }
  async function state(){
    const response=await timedFetch(cartPath+'?section_id=drv-gift-cart-state',{cache:'no-store'});
    if(!response.ok)throw new Error('Gift state unavailable');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const el=doc.querySelector('[data-drv-cart-state]');
    if(!el)throw new Error('Missing gift state');
    const data=JSON.parse(el.textContent);
    if(data.enabled!==true)throw new Error('Gift mode is not active');
    for(const item of data.items)if(Array.isArray(item.properties))item.properties=Object.fromEntries(item.properties);
    try{data.giftLimits=typeof data.giftLimits==='string'?JSON.parse(data.giftLimits.replace(/&quot;|&#34;/g,'"')):(data.giftLimits||{});}catch{data.giftLimits={};}
    if(!data.giftLimits||Array.isArray(data.giftLimits)||typeof data.giftLimits!=='object')data.giftLimits={};
    try{data.giftWaivers=typeof data.giftWaivers==='string'?JSON.parse(data.giftWaivers.replace(/&quot;|&#34;/g,'"')):(data.giftWaivers||{});}catch{data.giftWaivers={};}
    if(!data.giftWaivers||Array.isArray(data.giftWaivers)||typeof data.giftWaivers!=='object')data.giftWaivers={};
    if(Object.keys(data.giftLimits).length){
      data.giftWaivers=logic.migrateLimits(data,registered);
      await request(window.routes.cart_update_url,{attributes:{drv_gift_waivers:JSON.stringify(data.giftWaivers),drv_gift_limits:''}});
      data.giftLimits={};
    }
    return data;
  }
  function run(action){
    pending++;protect();
    const next=chain.then(action).then(result=>{failed=false;const error=document.querySelector('[data-drv-native-gift-error]');error.hidden=true;return result;}).catch(error=>{failed=true;showError();console.error('DRV gift cart:',error);throw error;}).finally(()=>{pending--;protect();});
    chain=next.catch(()=>{});
    return next;
  }
  async function reconcile(){
    let snapshot=await state();
    const change=logic.plan(snapshot,registered);
    if(Object.keys(change.updates).length)await request(window.routes.cart_update_url,{updates:change.updates});
    if(change.adds.length)await request(window.routes.cart_add_url,{items:change.adds});
    if(Object.keys(change.updates).length||change.adds.length)snapshot=await state();
    const remaining=logic.plan(snapshot,registered);
    if(Object.keys(remaining.updates).length||remaining.adds.length)throw new Error('Gift cart did not converge');
    return snapshot;
  }
  async function sections(ids){
    const result=await request(cartPath+'?sections='+ids.map(encodeURIComponent).join(','));
    if(ids.some(id=>!result[id]))throw new Error('Cart sections unavailable');
    return result;
  }
  async function render(cartUI){
    if(cartUI){const defs=cartUI.getSectionsToRender();const html=await sections(defs.map(s=>s.section||s.id));
      for(const def of defs){const host=document.getElementById(def.id);const dest=host?.querySelector(def.selector)||host;const doc=new DOMParser().parseFromString(html[def.section||def.id],'text/html');const source=doc.querySelector(def.selector);if(!dest||!source)throw new Error('Cart render target missing');dest.innerHTML=source.innerHTML;}
    }
    const current=await request(window.Shopify.routes.root+'cart.js');
    document.querySelector('cart-drawer')?.classList.toggle('is-empty',current.item_count===0);
    document.querySelector('cart-items')?.classList.toggle('is-empty',current.item_count===0);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty',current.item_count===0);
    if(window.publish)publish(PUB_SUB_EVENTS.cartUpdate,{source:'drv-native-gifts',cartData:current});
    return current;
  }
  window.DrvNativeGifts={
    applies(owner){return !!owner.closest('product-info')?.querySelector('[data-drv-gift-config]');},
    add(owner,accessories,options={}){
      owner.submitButton.setAttribute('aria-disabled','true');owner.submitButton.classList.add('loading');owner.querySelector('.loading__spinner')?.classList.remove('hidden');owner.handleErrorMessage();
      const fields=new FormData(owner.form),rule=JSON.parse(owner.closest('product-info').querySelector('[data-drv-gift-config]').textContent);
      let addAttempted=false,addConfirmed=false,mustReview=false;
      const main={id:fields.get('id'),quantity:Number(fields.get('quantity')||1)},properties={};
      for(const [key,value]of fields){const match=key.match(/^properties\[(.+)\]$/);if(match)properties[match[1]]=value;}
      if(Object.keys(properties).length)main.properties=properties;
      return run(async()=>{
        if(fields.get('selling_plan'))throw new Error('Gift subscription not configured');
        if(rule.enabled!==true)throw new Error('Model gift configuration not enabled');
        const before=await state();const items=logic.addItems(before,rule,main,accessories,registered);
        addAttempted=true;
        await request(window.routes.cart_add_url,{items});
        addConfirmed=true;
        await reconcile();
        if(options.checkout){mustReview=true;window.location.assign(window.Shopify.routes.root+'checkout');return;}
        if(owner.cart){const defs=owner.cart.getSectionsToRender();const html=await sections(defs.map(s=>s.id));owner.cart.setActiveElement(document.activeElement);owner.cart.renderContents({id:main.id,sections:html});await render();}
        else window.location.assign(cartPath);
      }).catch(()=>{mustReview=addAttempted;owner.handleErrorMessage(addConfirmed?'Items were added. Please open your cart to review them.':addAttempted?'Please open your cart to check whether items were added before trying again.':errorText());if(addAttempted)window.location.assign(cartPath);}).finally(()=>{if(!mustReview)owner.submitButton.removeAttribute('aria-disabled');owner.submitButton.classList.remove('loading');owner.querySelector('.loading__spinner')?.classList.add('hidden');});
    },
    change(owner,line,quantity){
      const row=owner.querySelector('#CartItem-'+line+', #CartDrawer-Item-'+line),key=row?.dataset.drvKey;
      const target=Number(quantity);
      return run(async()=>{
        if(!key||!Number.isSafeInteger(target)||target<0)throw new Error('Invalid cart line');
        const before=await state();const item=before.items.find(item=>item.key===key);
        if(!item){if(target===0)return render(owner);throw new Error('Cart line changed');}
        if(registered.includes(String(item.product_id))||item.managed){
          const allowed=logic.allowances(before,registered);
          const waivers={...before.giftWaivers,[String(item.variant_id)]:Math.max(0,(allowed[String(item.variant_id)]||0)-target)};
          await request(window.routes.cart_update_url,{attributes:{drv_gift_waivers:JSON.stringify(waivers)}});
          await reconcile();return render(owner);
        }
        const projected={...before,items:before.items.map(i=>i.key===key?{...i,quantity:target}:i)};
        const allowed=logic.allowances(projected,registered),waivers={};
        for(const [variant,q]of Object.entries(before.giftWaivers))waivers[variant]=Math.min(q,allowed[variant]||0);
        await request(window.routes.cart_update_url,{updates:{[key]:target},attributes:{drv_gift_waivers:JSON.stringify(waivers)}});
        await reconcile();return render(owner);
      }).catch(()=>{});
    }
  };
  document.addEventListener('click',event=>{
    if(!(pending||failed))return;
    if(event.target.closest('button[name="checkout"],a[href*="/checkout"]')){event.preventDefault();event.stopImmediatePropagation();showError();}
  },true);
  const init=()=>{for(const button of document.querySelectorAll('[data-drv-buy-now]')){if(button.closest('product-info')?.querySelector('[data-drv-gift-config]'))button.hidden=false;}return run(async()=>{const before=await state();const change=logic.plan(before,registered);await reconcile();if(Object.keys(change.updates).length||change.adds.length)await render(document.querySelector('cart-items')||document.querySelector('cart-drawer-items'));}).catch(()=>{});};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  window.addEventListener('pageshow',event=>{if(event.persisted)init();});
})();
